import combineReducers from '@americanexpress/vitruvius/immutable';
import { OneCache } from 'fetchye-one-app';
import { resourcesReducer } from 'iguazu-rest';
import productsReducer from 'axp-product-ducks';
import { experimentsReducer } from '@americanexpress/one-experiments';
import authReducer from './authDuck';
import searchReducer from './searchDuck';

const reducer = combineReducers({
  auth: authReducer,
  experiments: experimentsReducer,
  fetchye: OneCache().reducer,
  products: productsReducer,
  resources: resourcesReducer,
  search: searchReducer,
});

export default reducer;
